import script from "./ThirdView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThirdView.vue?vue&type=script&setup=true&lang=ts"

import "./ThirdView.vue?vue&type=style&index=0&id=3bcb79a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bcb79a4"]])

export default __exports__